import { Outlet } from "react-router"
import { chart } from "../assets/images/images"
import { useEffect, useState } from "react"
import Loading from "../component/Loading"
import ToastProvider from "../component/ToastProvider"
import { subscribe } from "../services/loadingServices/loading.service"

const AuthLayout = () => {
    const [loading, setLoading] = useState<boolean>(false);
    useEffect(() => {
        subscribe("loading", (data: any) => {
            setLoading(data.detail)
        })
    })
    return (

        <div className="h-screen relative">
            {loading && <Loading />}
            {/* Sign-in, sign-up and password pages report API errors through the same toast. */}
            <ToastProvider />
            <div className="grid grid-cols-12 h-full">
                <div className="col-span-5 px-16 relative max-lg:col-span-full max-xs:px-2">
                    <Outlet />
                </div>
                <div className="col-span-7 relative rounded-2xl overflow-hidden bg-sigin-in h-full w-full bg-no-repeat bg-center bg-contain max-lg:hidden bg-[#F8F8F8]">
                </div>
            </div>
        </div>
    )
}
export default AuthLayout



